@if (controlErrors(); as errors) {
  <div class="input-error">
    @if (errors.required) {
      <div><small i18n>This field is required</small></div>
    }
    @if (errors.minlength; as err) {
      <div><small i18n>This field is too short, minimum : {{err.requiredLength}} characters.</small></div>
    }
    @if (errors.maxlength; as err) {
      <div><small i18n>This field is too long, maximum : {{err.requiredLength}} characters.</small></div>
    }
    @if (errors.min; as err) {
      <div><small i18n>Invalid value, minimum: {{ err.min }}</small></div>
    }
    @if (errors.max; as err) {
      <div><small i18n>Invalid value, maximum: {{ err.max }}</small></div>
    }
    @if (errors.invalidDuration; as err) {
      <div><small i18n>Invalid duration</small></div>
    }
    @if (errors.inputDateInvalid; as err) {
      <small i18n>Invalid date</small>
    }
    @if (errors.inputDateMinInvalid; as err) {
      <small i18n>The date must be greater than: {{ err.minDate | date: 'dd/MM/yyyy HH:mm' }}</small>
    }
    @if (errors.canEnterUntilMDateMinInvalid; as err) {
      <small i18n>The until date must be greater than: {{ err.minDate | date: 'dd/MM/yyyy HH:mm' }}</small>
    }
  </div>
}
